import { useCallback, useEffect, useMemo, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

// /brokers?tab=certs&q=foo
// Same pattern as the admin portal's useAdminTab.

const DEFAULT_TAB = 'certs';

export default function useBrokerTab() {
    const navigate = useNavigate();
    const location = useLocation();

    const params = useMemo(
        () => new URLSearchParams(location.search),
        [location.search]
    );

    const tab = params.get('tab') || DEFAULT_TAB;
    const filters = useMemo(() => {
        const obj = {};
        for (const [k, v] of params.entries()) {
            if (k !== 'tab') obj[k] = v;
        }
        return obj;
    }, [params]);

    const goTo = useCallback(
        ({ tab: nextTab, ...nextFilters } = {}, opts = {}) => {
            const sp = new URLSearchParams();
            sp.set('tab', nextTab || tab);
            for (const [k, v] of Object.entries(nextFilters)) {
                if (v !== undefined && v !== null && v !== '') sp.set(k, String(v));
            }
            const search = `?${sp.toString()}`;
            if (opts.replace) navigate({ pathname: '/brokers', search }, { replace: true });
            else navigate({ pathname: '/brokers', search });
        },
        [navigate, tab]
    );

    // Translate legacy navigate('/brokers', { state: { section, certNumber } }) calls.
    const [legacyApplied, setLegacyApplied] = useState(false);
    useEffect(() => {
        if (legacyApplied) return;
        const ls = location.state;
        if (ls && ls.section) {
            const mapped = ls.section.toLowerCase();
            goTo({ tab: mapped, ...(ls.certNumber ? { certNumber: ls.certNumber } : {}) }, { replace: true });
            setLegacyApplied(true);
        }
    }, [location.state, legacyApplied, goTo]);

    return { tab, filters, goTo };
}
